<div class="signature-modal">
    <section class="modal-header">
        <h3>Solicitar Firma Electrónica</h3>
        <button mat-icon-button (click)="closeDialog()">
            <mat-icon>close</mat-icon>
        </button>
    </section>

    <form [formGroup]="signatureForm" (ngSubmit)="onSubmit()">
        <section class="modal-body">
            <mat-form-field appearance="outline" class="w-100">
                <mat-label>RUT</mat-label>
                <input type="text"
                       matInput
                       formControlName="rut"
                       placeholder="Ingrese RUT"
                       [matAutocomplete]="auto"
                       (focus)="onFocusRut()"
                       (click)="onFocusRut()">
                <button mat-icon-button matSuffix *ngIf="fieldsLocked" (click)="clearSelection()" type="button">
                    <mat-icon>close</mat-icon>
                </button>
                <mat-autocomplete #auto="matAutocomplete" 
                                [displayWith]="displayFn"
                                (optionSelected)="onOwnerSelected($event)">
                    <mat-option *ngFor="let owner of filteredOwners | async" [value]="owner">
                        {{owner.fullRut}} - {{owner.completeName}}
                    </mat-option>
                </mat-autocomplete>
                <mat-error *ngIf="signatureForm.get('rut')?.hasError('required')">
                    El RUT es requerido
                </mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" class="w-100">
                <mat-label>Nombre</mat-label>
                <input matInput 
                       formControlName="nombre" 
                       placeholder="Ingrese nombre completo"
                       [readonly]="fieldsLocked">
                <mat-error *ngIf="signatureForm.get('nombre')?.hasError('required')">
                    El nombre es requerido
                </mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" class="w-100">
                <mat-label>Correo Electrónico</mat-label>
                <input matInput 
                       formControlName="email" 
                       placeholder="Ingrese correo electrónico"
                       [readonly]="fieldsLocked">
                <mat-error *ngIf="signatureForm.get('email')?.hasError('required')">
                    El correo electrónico es requerido
                </mat-error>
                <mat-error *ngIf="signatureForm.get('email')?.hasError('email')">
                    Ingrese un correo electrónico válido
                </mat-error>
            </mat-form-field>
        </section>

        <section class="modal-footer">
            <button mat-button (click)="closeDialog()">Cancelar</button>
            <button mat-raised-button color="primary" type="submit" [disabled]="!signatureForm.valid">
                Solicitar Firma
            </button>
        </section>
    </form>
</div>
